import React from "react";
import {
  HomeIcon,
  ChartBarIcon,
  //Cog6ToothIcon,
  //UserCircleIcon,
  DocumentTextIcon,
  BanknotesIcon,
} from "@heroicons/react/24/outline";

const LeftNav: React.FC = () => {
  return (
    <>
      <aside className="w-64 bg-white shadow-lg">
        <div className="p-6 text-center text-xl font-bold text-blue-600">
          <img
            src="/logo-gibitsoft-2000.png"
            alt="Logo"
            className="mx-auto h-12 w-auto"
          />
        </div>
        <nav className="mt-6">
          <ul className="space-y-2">
            <li>
              <a
                href="/"
                className="flex items-center space-x-3 rounded-lg px-4 py-2 text-gray-700 transition hover:bg-blue-100"
              >
                <HomeIcon className="h-5 w-5" />
                <span>Inicio</span>
              </a>
            </li>
            <li>
              <a
                href="/bills"
                className="flex items-center space-x-3 rounded-lg px-4 py-2 text-gray-700 transition hover:bg-blue-100"
              >
                <DocumentTextIcon className="h-5 w-5" />
                <span>Gestion de Pagos</span>
              </a>
            </li>
            <li>
              <a
                href="/viaticos"
                className="flex items-center space-x-3 rounded-lg px-4 py-2 text-gray-700 transition hover:bg-blue-100"
              >
                <BanknotesIcon className="h-5 w-5" />
                <span>Gestion de Viaticos</span>
              </a>
            </li>

            <li>
              <a
                href="/reports"
                className="flex items-center space-x-3 rounded-lg px-4 py-2 text-gray-700 transition hover:bg-blue-100"
              >
                <ChartBarIcon className="h-5 w-5" />
                <span>Reportes</span>
              </a>
            </li>
            {/*
            <li>
              <a
                href="/"
                className="flex items-center space-x-3 rounded-lg px-4 py-2 text-gray-700 transition hover:bg-blue-100"
              >
                <UserCircleIcon className="h-5 w-5" />
                <span>Usuarios</span>
              </a>
            </li>

            <li>
              <a
                href="/"
                className="flex items-center space-x-3 rounded-lg px-4 py-2 text-gray-700 transition hover:bg-blue-100"
              >
                <Cog6ToothIcon className="h-5 w-5" />
                <span>Configuración</span>
              </a>
            </li>
*/}
          </ul>
        </nav>
      </aside>
    </>
  );
};

export default LeftNav;
